/* Copyright 2021, Milkdown by Mirone. */

export enum ToolTipPos {
    Left = 'Left',
    Top = 'Top',
    Point = 'Point',
}
